<template>
    <div class="block-view">
       <div class="mt-3 pt-3">
          <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Sales Pipeline</li>
                <li class="breadcrumb-item clickable-row" aria-current="page" @click="goToContractsPage">Contracts</li>
                <li class="breadcrumb-item " aria-current="page">Vertex Cyber Security Contract </li>
             </ol>
          </nav>
       </div>
 
       <div>
          <ContractView :id="id"/>
       </div>
 
    </div>
 
    <!-- <div>
  
        <div class="text-center">
           <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
              <ol class="breadcrumb">
                 <li class="breadcrumb-item" aria-current="page">Page Not Found</li>
              </ol>
           </nav>BlockDetailedView
        </div>
  
     </div> -->
 </template>
 
 <script>
 import ContractView from "@/components/Contracts/ContractView.vue"
 
 export default ({
 
    components: {
        ContractView
    },
 
    props: {
       id: {
          type: String,
       },
       block_type: {
          type: String,
       }
    },
 
    data() {
       return {
          title: "",
          organisationId: 0,
       }
    },
 
    computed: {
       item() {
          return this.id
       },
 
       currentOrg() {
          return this.$store.state.auth.currentOrganisation.id
       }
 
    },
 
    watch: {
       item() {
          this.init()
       },
    },
 
    created() {

    },
 
    methods: {
       goToContractsPage() {
          this.$router.push({ name: 'Contracts' })
       }
    },
 })
 </script>
 
 <style scoped>
 .clickable-row:hover {
    text-decoration: underline;
 }
 </style>
